/**
 * Navigation config for public marketing headers (routes, hashes, external URLs).
 * Developer and blog links use in-app routes that mirror www.quillai.app (placeholders until content ships).
 *
 * @typedef {{ label: string, to?: string, href?: string }} MarketingNavItem
 */

/** @type {ReadonlyArray<MarketingNavItem>} */
export const MARKETING_NAV_PRODUCT_LINKS = [
  { label: "Features", to: "/#features" },
  { label: "Pricing", to: "/pricing" },
  { label: "How it works", to: "/#how-it-works" },
  { label: "Product demo", to: "/#product-video" },
];

/** @type {ReadonlyArray<MarketingNavItem>} */
export const MARKETING_NAV_RESOURCES_LINKS = [
  { label: "Blog", to: "/blog" },
  { label: "Documentation", to: "/devs/documentation" },
];
